<div
  (mouseover)="verifyOpenPosition($event)"
  (mouseout)="showLegendComponent = false"
  (focus)="verifyOpenPosition($event)"
  (blur)="showLegendComponent = false"
  tabindex="0"
>
  <ng-content></ng-content>
  <div
    [hidden]="!showLegendComponent"
    class="ring-color-container"
    [ngStyle]="dynamicallyPosition ? dynamicallyPositionStyle : ringContainerPosition"
  >
    <div class="legend-header">
      <span>{{ legendName ?? 'Legend' }}</span>
    </div>
    <div class="legend-body">
      @for (item of ringColorsList; track item) {
        <div class="legend-item">
          <div class="legend-dot" style="--color: {{ item.color }}"></div>
          <div class="legend-name">{{ item.description }}</div>
        </div>
      }
    </div>
  </div>
</div>
